// ─── Shared JS breakpoint constants ───────────────────────────────────────────
// The single source of truth for the layout breakpoints, so `useMediaQuery`
// (JS) and the grid CSS in index.css / responsive.css can never drift. Per
// CLAUDE.md we do NOT write inline `@media` in TSX — instead we render-gate on
// `useMediaQuery(MOBILE_QUERY)` and keep the CSS using the SAME pixel values.
//
// Matches responsive.css: compact ≤640, medium 641–1024, expanded >1024.
export const BREAKPOINT_COMPACT = 640;
export const BREAKPOINT_EXPANDED = 1024;

/**
 * The dashboard collapses to its 2-up mobile grid at the compact breakpoint
 * (≤640px). The active breakpoint selects whether a placed widget renders with
 * its desktop (width/visibility) or its mobile (width/visibility) config.
 */
export const MOBILE_QUERY = `(max-width: ${BREAKPOINT_COMPACT}px)` as const;
